import { IntercomAPI as intercomAPI } from 'react-intercom';

export const logEvent = (event, properties) => intercomAPI('trackEvent', event, properties);
